<template>
  <div class="border">
    <el-dialog :fullscreen="true" :visible.sync="ifshow" @open="openDialog" :before-close="closeDialog">
      <el-row type="flex" style="margin-bottom: 20px;margin-top: -30px;">
        <el-col :span="24">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item>{{strategy.name}}[{{getLabelByValue('strategyStatus', strategy.status)}}]</el-breadcrumb-item>
            <el-breadcrumb-item>组件池</el-breadcrumb-item>
            <el-breadcrumb-item>{{(strategyItem.code ? ('[' + strategyItem.code + ']' + strategyItem.name) : '新增评分卡')}}</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-form :inline="true" :model="scoreCardForm" ref="scoreCardForm" label-width="60px">
        <el-row type="flex" :gutter="20">
          <el-col :span="19">
            <el-card class="box-card" shadow="never">
              <el-row type="flex">
                <el-col :span="21">
                  <el-form-item label="code" prop="code" :rules="[{ required: true, message: '请输入评分卡编号', trigger: 'blur' }]">
                    <el-input v-model="scoreCardForm.code" placeholder="评分卡编号" style="width: 400px;" :readonly="strategyItem.code && strategyItem.code !== ''" :class="{'is-disabled': strategyItem.code}"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item style="float: right;">
                    <el-button type="success" size="small" @click="save('scoreCardForm')">保存</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex">
                <el-col :span="24">
                  <el-form-item label="名称" prop="name" :rules="[{ required: true, message: '请输入评分卡                                                                                                                                                                                                                                                                                                                          名称', trigger: 'blur' }]">
                    <el-input v-model="scoreCardForm.name" placeholder="评分卡名称" style="width: 400px;"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex">
                <el-col :span="24">
                  <el-form-item label="描述">
                    <el-input type="textarea" rows="3" cols="150" v-model="scoreCardForm.description" placeholder="描述"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
            <el-row type="flex" style="margin-top: 10px;">
              <el-col :span="24">
                <el-button type="primary" size="mini" @click="addScoreItem">新增平分项</el-button>
              </el-col>
            </el-row>
            <el-card class="box-card" shadow="never" v-for="(scoreItem, i) in scoreCardForm.viewDataJson.scoreItems" :key="'scoreItems.' + i" style="margin-top: 5px;">
              <el-row type="flex">
                <el-col :span="1">
                  <el-button type="danger" icon="el-icon-minus" size="mini" circle @click="deleteScoreItem(i)"></el-button>
                </el-col>
                <el-col :span="2" style="text-align: center">
                  <span style="height:40px;line-height: 40px">评分项【{{i+1}}】</span>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="" :prop="'viewDataJson.scoreItems.' + i + '.variable.value'"
                                :rules="{required: true, message: '引用变量不能为空', trigger: 'blur'}">
                    <tribute-mention :value.sync="scoreItem.variable" :sources="variableSources" @updateTargets="syncTestData"></tribute-mention>
                  </el-form-item>
                </el-col>
                <el-col :span="14">
                  <el-form-item label="权重" :prop="'viewDataJson.scoreItems.' + i + '.weight'" style="float: right;"
                                :rules="[{ required: true, message: '请输入权重值', trigger: 'blur'}]">
                    <el-input v-model="scoreItem.weight" style="width: 100px;"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex">
                <el-col :span="1">
                  <el-button type="success" icon="el-icon-plus" circle size="mini" @click="addItemRow(i)" style="float: right; margin-right: 5px; margin-top: 10px;"></el-button>
                </el-col>
                <el-col :span="22">
                  <el-editable :ref="'tableDataTable'+i" :data.sync="scoreItem.itemData" border highlight-current-row style="width: 100%" empty-text="请新增平分项">
                    <el-editable-column type="index" label="index" align="center" width="60"></el-editable-column>
                    <el-editable-column prop="scopeRule" label="范围" :editRender="{name: 'ElMention', sources: scoreItem.variable.targets}" :editHeaderTag="false"></el-editable-column>
                    <el-editable-column prop="score" align="center" label="score" width="200" :editRender="{name: 'ElInput'}" :editHeaderTag="false"></el-editable-column>
                    <el-editable-column label="操作" width="150">
                      <template slot-scope="scope">
                        <el-button @click="deleteItemRow(i, scope.$index)" type="text" size="small">删除</el-button>
                      </template>
                    </el-editable-column>
                  </el-editable>
                </el-col>
              </el-row>
            </el-card>
            <!-- 评分卡输出项 -->
            <el-card class="box-card" shadow="never" style="margin-top: 20px;background: #f7f7f7">
              <el-row type="flex">
                <el-col :span="24" style="margin-bottom: 20px;">OUTPUT</el-col>
              </el-row>
              <el-row type="flex">
                <el-col :span="1">
                  <el-button type="success" icon="el-icon-plus" circle size="mini" @click="addOutputItemRow()" style="float: right; margin-right: 5px; margin-top: 10px;"></el-button>
                </el-col>
                <el-col :span="22">
                  <el-editable ref="outputTableDataTable" :data.sync="scoreCardForm.viewDataJson.outputScoreLevel" border highlight-current-row style="width: 100%" empty-text="请新增输出项">
                    <el-editable-column type="index" label="index" align="center" width="60"></el-editable-column>
                    <el-editable-column prop="scoreRule" label="score" :editRender="{name: 'ElInput'}" :editHeaderTag="false"></el-editable-column>
                    <el-editable-column prop="scoreLevel" label="level" align="center" width="200" :editRender="{name: 'ElInput'}" :editHeaderTag="false"></el-editable-column>
                    <el-editable-column label="操作" width="150">
                      <i class="el-icon-edit"></i>
                      <template slot-scope="scope">
                        <el-button @click="deleteOutputItemRow(scope.$index)" type="text" size="small">删除</el-button>
                      </template>
                    </el-editable-column>
                  </el-editable>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="5">
            <el-card class="box-card test-card" style="height: 100%;">
              <div slot="header" class="clearfix">
                <span>输入测试</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="testExpression">测试</el-button>
              </div>
              <div class="text item">
                <div style="margin-bottom: 5px;display: flex;" v-for="(val, key, testIndex) in scoreCardForm.viewDataJson.testData" :key="'testData.' + testIndex">
                  <span style="width: 60%;display: block;float: left;height: 40px;line-height: 40px;">{{key}}</span>
                  <el-input v-model="scoreCardForm.viewDataJson.testData[key]" style="width: 40%;float: right"></el-input>
                </div>
                <div style="border: solid 1px #ccc3c3;width: 96%;height: 165px;margin-top: 30px;border-radius: 5px;padding: 10px;font-size: 15px;word-break: break-all;">
                  {{scoreCardForm.viewDataJson.testResult}}
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-form>
      <div style="height: 320px"></div>
    </el-dialog>
  </div>
</template>

<script>
import debounce from 'throttle-debounce/debounce'
import {clone, loadMentionSources} from '@/utils/common'
import Editable from '@/components/editable/Editable.vue'
import EditableColumn from '@/components/editable/EditableColumn.vue'
import TributeMention from '@/components/mention/tributeMention.vue'

export default {
  components: {
    'el-editable': Editable,
    'el-editable-column': EditableColumn,
    'tribute-mention': TributeMention
  },
  props: {
    ifshow: Boolean,
    strategyItem: Object,
    strategy: Object
  },
  data () {
    return {
      scoreCardForm: {
        code: '',
        name: '',
        description: '',
        type: 3,
        viewData: '',
        expression: '',
        viewDataJson: {
          scoreItems: [
            {
              variable: {value: '', targets: []},
              weight: 1.0,
              itemData: [{
                scopeRule: '',
                score: null
              }]
            }
          ],
          outputScoreLevel: [
            {
              scoreRule: 'score <= 0',
              scoreLevel: 'L0'
            }
          ],
          testData: {},
          testResult: ''
        },
        strategyRefVariables: []
      },
      viewDataJsonTemplate: {
        scoreItems: [
          {
            variable: {value: '', targets: []},
            weight: 1.0,
            itemData: [{
              scopeRule: '',
              score: null
            }]
          }
        ],
        outputScoreLevel: [
          {
            scoreRule: 'score <= 0',
            scoreLevel: 'L0'
          }
        ]
      },
      strategyItemOutputsTemplate: [],
      strategyRefVariableMap: new Map(),
      variableSources: []
    }
  },
  created () {
  },
  methods: {
    async openDialog () {
      console.info('打开评分卡弹框')
      // console.info(JSON.stringify(this.strategy))
      // console.info(JSON.stringify(this.strategyItem))
      if (this.$refs['scoreCardForm'] && this.$refs['scoreCardForm'].resetFields()) {
        this.$refs['scoreCardForm'].resetFields()
      }
      this.scoreCardForm.strategyId = this.strategy.id
      let strategyItem = this.strategyItem
      this.scoreCardForm.id = strategyItem.id
      this.scoreCardForm.code = strategyItem.code
      this.scoreCardForm.name = strategyItem.name
      this.scoreCardForm.description = strategyItem.description
      // 加载策略下所有变量源 并且排除当前组件的输出
      this.variableSources = await loadMentionSources.doLoadSourcesExcludeCurrentModelOutput(this.strategy.id, strategyItem.code)
      this.$data.scoreCardForm.viewDataJson = strategyItem.viewData ? JSON.parse(strategyItem.viewData) : clone(this.viewDataJsonTemplate)
    },
    closeDialog () {
      this.$emit('handleCloseDialog')
    },
    addScoreItem () {
      this.scoreCardForm.viewDataJson.scoreItems.push(clone(this.viewDataJsonTemplate.scoreItems[0]))
    },
    deleteScoreItem (i) {
      this.scoreCardForm.viewDataJson.scoreItems.splice(i, 1)
    },
    addItemRow (i) {
      this.$refs['tableDataTable' + i][0].insertAt(clone(this.viewDataJsonTemplate.scoreItems[0].itemData[0]), -1)
    },
    deleteItemRow (i, rowIndex) {
      this.$refs['tableDataTable' + i][0].removeRow(rowIndex)
    },
    addOutputItemRow () {
      this.$refs['outputTableDataTable'].insertAt(clone(this.viewDataJsonTemplate.outputScoreLevel[0]), -1)
    },
    deleteOutputItemRow (rowIndex) {
      this.$refs['outputTableDataTable'].removeRow(rowIndex)
    },
    save: debounce(300, async function (formName) {
      let validRes = false
      this.$refs[formName].validate(valid => {
        validRes = valid
      })
      if (!validRes) {
        return false
      }
      // 表达式校验 校验测试是否通过
      let testRes = await this.testExpression()
      if (!testRes) {
        return
      }
      this.$confirm('请确认是否保存？').then(async () => {
        try {
          const params = clone(this.scoreCardForm)
          params.strategyItemOutputs = [
            {name: this.scoreCardForm.code + '_score', dataType: 2},
            {name: this.scoreCardForm.code + '_level', dataType: 1}
          ]
          delete params.viewDataJson
          console.info(JSON.stringify(params))
          const res = await this.$http.post('/strategy/item', params)
          if (res.code === '200') {
            this.$message.success('保存成功!')
            this.closeDialog()
          } else {
            this.$message.error(res.message)
          }
        } catch (err) {
          console.error(err)
        }
      }).catch(() => {
      })
    }),
    generateExpression () {
      this.strategyRefVariableMap.clear()
      this.scoreCardForm.strategyRefVariables = []
      if (this.scoreCardForm.viewDataJson.scoreItems.length === 0) {
        this.$message.error('请新增平分项')
        return false
      }
      let scoreCardCode = this.scoreCardForm.code
      let expressionStr = 'int m_' + scoreCardCode + '_score_total = 0;'
      for (let i in this.scoreCardForm.viewDataJson.scoreItems) {
        let numberI = Number(i) + 1
        let scoreItem = clone(this.scoreCardForm.viewDataJson.scoreItems[i])
        if (scoreItem.variable.targets.length === 0) {
          this.$message.error('平分项【' + numberI + '】有引用变量无效，请重新选择')
          return false
        }
        let variable = scoreItem.variable.targets[0]
        let weight = scoreItem.weight
        let itemData = scoreItem.itemData
        if (itemData.length === 0) {
          this.$message.error('平分项【' + numberI + '】的规则不能为空')
          return false
        }
        for (let j in itemData) {
          let numberJ = Number(j) + 1
          let item = clone(itemData[j])
          let scopeRule = item.scopeRule
          let score = item.score
          if (scopeRule === null || scopeRule === '') {
            this.$message.error('平分项【' + numberI + '】第' + numberJ + '行范围表达式不能为空')
            return false
          }
          if (score === null || score === '') {
            this.$message.error('平分项【' + numberI + '】第' + numberJ + '行score不能为空')
            return false
          }
          expressionStr += `${numberJ > 1 ? 'else ' : ''}if(${scopeRule}){m_${scoreCardCode}_score_total += ${score * weight};}`
        }
        expressionStr += `else{m_${scoreCardCode}_score_total += 0;}`
        if (!this.strategyRefVariableMap[scoreItem.variable.value]) {
          this.strategyRefVariableMap.set(scoreItem.variable.value, scoreItem.variable.targets)
          let refVariable = {}
          refVariable.name = variable.name
          refVariable.refId = variable.id
          refVariable.refVariableType = variable.refType
          this.scoreCardForm.strategyRefVariables.push(refVariable)
        }
      }
      // 计算平分输出项等级
      for (let k in this.scoreCardForm.viewDataJson.outputScoreLevel) {
        let numberK = Number(k) + 1
        let output = clone(this.scoreCardForm.viewDataJson.outputScoreLevel[k])
        let scoreRule = output.scoreRule
        let scoreLevel = output.scoreLevel
        if (!scoreRule || scoreRule === null || scoreRule === '') {
          this.$message.error('输出平分等级规则第' + numberK + '行score表达式不能为空')
          return false
        }
        if (scoreLevel === null || scoreLevel === '') {
          this.$message.error('输出平分等级规则第' + numberK + '行等级不能为空')
          return false
        }
        scoreRule = scoreRule.replace(/score/g, 'm_' + scoreCardCode + '_score_total')
        if (numberK !== 1) expressionStr += 'else '
        expressionStr += `if(${scoreRule}){{"${scoreCardCode}_score":m_${scoreCardCode}_score_total, "${scoreCardCode}_level": "${scoreLevel}"}}`
      }
      expressionStr += `else{{"${scoreCardCode}_score":m_${scoreCardCode}_score_total, "${scoreCardCode}_level":""}}`
      expressionStr = expressionStr.replace(/@s./g, 's_').replace(/@m./g, 'm_').replace(/@e./g, '')
        .replace(/[$]max/g, this.mvelConfig.actionOptions.max).replace(/[$]min/g, this.mvelConfig.actionOptions.min)
      this.scoreCardForm.viewData = JSON.stringify(this.scoreCardForm.viewDataJson)
      this.scoreCardForm.expression = expressionStr
      return true
    },
    syncTestData ({key, value}) {
      console.info(key + ' : ' + JSON.stringify(value))
      let testData = {}
      for (let i in this.scoreCardForm.viewDataJson.scoreItems) {
        let variable = clone(this.scoreCardForm.viewDataJson.scoreItems[i]).variable
        if (variable && variable.targets && variable.targets.length > 0) {
          for (let j in variable.targets) {
            let name = clone(variable.targets[j]).name
            if (this.scoreCardForm.viewDataJson.testData[name]) {
              testData[name] = this.scoreCardForm.viewDataJson.testData[name]
            } else {
              testData[name] = null
            }
          }
        }
      }
      this.scoreCardForm.viewDataJson.testData = testData
    },
    async testExpression () {
      let validRes = false
      this.$refs['scoreCardForm'].validate(valid => {
        validRes = valid
      })
      if (!validRes) {
        return false
      }
      if (!this.generateExpression()) {
        return false
      }
      let testData = this.scoreCardForm.viewDataJson.testData
      for (let key in testData) {
        let testDataValue = testData[key]
        let reg = new RegExp(/^[-]?\d+(\.\d+)?$/)
        if (reg.test(testDataValue)) {
          testData[key] = Number(testDataValue)
        }
      }
      testData = JSON.stringify(testData)
      try {
        const params = {
          expression: this.scoreCardForm.expression,
          env: testData
        }
        const res = await this.$http.post(`/common/expressions/evaluator`, params)
        if (res.code === '200') {
          this.scoreCardForm.viewDataJson.testResult = JSON.stringify(res.data)
          this.$message.success('测试通过!')
          return true
        } else {
          this.$message.error('测试未通过!')
          this.scoreCardForm.viewDataJson.testResult = res.message
        }
      } catch (err) {
        console.error(err)
      }

      return false
    }
  }
}
</script>

<style lang="stylus" scoped>
  .test-card .el-form-item__label {
    width: 55% !important;
    text-align: left !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/component/score-card.vue